import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import BossSettingLangModal from "./BossSettingLangModal";

const languageDisplay = {
  en: "English",
  ar: "العربية",
  he: "עברית",
};

export default function BossSettingHeader() {
  const { t } = useTranslation();
  const [openLangModal, setOpenLangModal] = useState(false);

  // Read current lang from localStorage
  const stored = localStorage.getItem("lang");
  const lang = stored ? JSON.parse(stored) : "en";

  return (
    <div className="bg-white border-b border-gray-100 shadow-sm">
      <div className="flex items-center justify-between px-4 py-4">
        {/* Title */}
        <h1 className="text-3xl font-bold text-slate-800 tracking-tight">
          {t("settings")}
        </h1>

        {/* Language button */}
        <button
          onClick={() => setOpenLangModal(true)}
          className="flex items-center gap-2 bg-sky-500 hover:bg-sky-600 text-white font-semibold text-sm px-4 py-2 rounded-full shadow-md transition"
        >
          <Globe className="w-5 h-5" />
          <span>{languageDisplay[lang] || t("languageEnglish")}</span>
        </button>
      </div>

      {/* Language modal */}
      <BossSettingLangModal
        visible={openLangModal}
        onClose={() => setOpenLangModal(false)}
      />
    </div>
  );
}
